/**
 * Google Tag Manager (GTM) / DataLayer tracking utilities
 * Ensures custom events are dispatched reliably in React SPA environments
 */

export const pushToDataLayer = (data) => {
  if (typeof window !== 'undefined') {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(data);
  }
};

/**
 * Track WhatsApp button / link clicks
 * Dispatches 'whatsapp_click' event to dataLayer
 * @param {string} source - where the click originated (e.g. 'hero_lead_card_whatsapp', 'mobile_sticky_bar_whatsapp')
 */
export const trackWhatsAppClick = (source = 'unknown') => {
  pushToDataLayer({
    event: 'whatsapp_click',
    click_source: source,
  });
};

/**
 * Track phone call CTA clicks (tel: links)
 * Dispatches 'call_click' event to dataLayer
 * @param {string} source - where the click originated (e.g. 'mobile_sticky_bar_call', 'header_phone')
 */
export const trackCallClick = (source = 'unknown') => {
  pushToDataLayer({
    event: 'call_click',
    click_source: source,
  });
};

/**
 * Track generic CTA button clicks (e.g. modal open, header CTA)
 * Dispatches 'cta_click' event to dataLayer
 * @param {string} label - descriptive label for the CTA
 */
export const trackCtaClick = (label = 'unknown') => {
  pushToDataLayer({
    event: 'cta_click',
    cta_label: label,
  });
};

/**
 * Track successful lead form submissions
 * Dispatches 'lead_form_submit' event to dataLayer
 * @param {string} formName - identifier for the form (e.g. 'standard-auditing-hero')
 */
export const trackLeadFormSubmit = (formName = 'lead_form') => {
  pushToDataLayer({
    event: 'lead_form_submit',
    form_name: formName,
  });
};

/**
 * Track Thank You page views
 * Dispatches 'thank_you_view' event to dataLayer
 */
export const trackThankYouView = () => {
  pushToDataLayer({
    event: 'thank_you_view',
    page_path: '/thank-you',
  });
};
